module.exports = __webpack_public_path__ + "img/faq-bubble-bg.327679f6.png";